import sanitizeHtml from 'sanitize-html';

interface SanitizeHTMLProps {
  className?: string;
  html: string;
  options?: sanitizeHtml.IOptions;
}

const defaultOptions = {
  allowedTags: ['b', 'i', 'em', 'strong', 'a', 'br'],
  allowedAttributes: {
    a: ['href'],
  },
  allowedIframeHostnames: [],
};

const sanitize = (dirty: string, options?: sanitizeHtml.IOptions) => ({
  __html: sanitizeHtml(dirty, options ? { ...defaultOptions, ...options } : defaultOptions),
});

export const SanitizeHTML = ({ className, html, options }: SanitizeHTMLProps) => (
  // eslint-disable-next-line react/no-danger
  <div className={className} dangerouslySetInnerHTML={sanitize(html, options)} />
);
